/***
 * Vue 设置默认值的插件
 * 采用 mixin混入的方式为 Vue 组件添加初始化默认值方法($initXXX)和 来自 Vuex 的 computed 默认值（$default）
 * 暂不支持复杂对象的初始化
 */
import {mapGetters} from 'vuex'

export default {
    install(Vue, option) {
        const {$default} = mapGetters({$default: 'default/all'})

        Vue.mixin({
            computed: {$default}, methods: {
                $initOrgan(target, rule = {'unitId': 'id', 'unitName': 'name'}) {
                    const {organ} = this.$default
                    if (organ) {
                        setValue.call(this, target, rule, organ)
                    }
                    return organ
                },
                $initUnit(target, rule = {'unitId': 'id', 'unitName': 'name'}) {
                    const {unit} = this.$default
                    if (unit) {
                        setValue.call(this, target, rule, unit)
                    }
                    return unit
                },
                $initArea(target, rule = {'areaId': 'id', 'areaName': 'name'}) {
                    const {area} = this.$default
                    if (area) {
                        setValue.call(this, target, rule, area)
                    }
                    return area
                },
                $initProduct(target, rule = {'productId': 'id', 'productName': 'productName'}) {
                    const {product} = this.$default
                    if (product) {
                        setValue.call(this, target, rule, product)
                    }
                    return product
                },
            }
        })
    }
}

/**
 * 设置默认值
 * @param target 被设置的对象
 * @param rule   设置的规则，{'被设置的对象的key':'数据源对象的key'}
 * @param source 数据源对象
 */
function setValue(target, rule, source) {
    Object.keys(rule).forEach(key => {
        // target[key] = source[rule[key]]
        this.$set(target, key, source[rule[key]])
    })
}